import { render, staticRenderFns } from "./StudentBalanceTop.vue?vue&type=template&id=2074ad83&"
import script from "./StudentBalanceTop.vue?vue&type=script&lang=ts&"
export * from "./StudentBalanceTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports